import React, { ReactNode } from 'react';
import { Button, Grid } from '@mui/material';
import PolarisIcon from '@/components/_common/PolarisIcon';

interface TitleDetailMetadataButtonsProps {
  editMode: boolean;
  setEditMode: (value: boolean) => void;
  handleSubmit: () => void;
  handleCancel: () => void;
  children?: ReactNode;
}

const TitleDetailMetadataButtons = ({ editMode, setEditMode, handleSubmit, handleCancel, children }: TitleDetailMetadataButtonsProps) => {
  return (
    <Grid container justifyContent="flex-end" alignItems="center">
      {editMode ? (
        <>
          <Button color="default" sx={{ mr: 2 }} onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Save Changes
          </Button>
        </>
      ) : (
        <>
          <Button variant="text" sx={{ height: 35 }} startIcon={<PolarisIcon icon="edit" height={15} />} onClick={() => setEditMode(true)}>
            Edit
          </Button>
          {children}
        </>
      )}
    </Grid>
  );
};

export default TitleDetailMetadataButtons;
